/**
 * Envision customizations
 * assets/spice-set-product.js
 *
 * Spice Set product page JavaScript
 */

(function () {

    /**
     * Accordions (todo: use native theme accordion instead)
     */

    const accordions = document.getElementsByClassName("accordion");

    [...accordions].forEach(accordion => {
        accordion.addEventListener("click", function() {
            this.classList.toggle("active");
            const panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                const readMore = panel.querySelector('.read-more');
                const tabContents = panel.querySelectorAll('.tabcontent');
                if (readMore) {
                    readMore.click();
                    panel.style.maxHeight = panel.scrollHeight + "px";
                    panel.querySelector('.read-less').click();
                } else if (tabContents) {
                    let greatestTabContentHeight = 0;
                    for (let i = 0; i < tabContents.length; i++) {
                        tabContents[i].style.display = 'block';
                        let currentTabContentHeight = panel.scrollHeight;
                        if (currentTabContentHeight > greatestTabContentHeight) {
                            greatestTabContentHeight = currentTabContentHeight;
                        }
                        if (i > 0) {
                            tabContents[i].style.display = 'none';
                        }
                    }
                    panel.style.maxHeight = greatestTabContentHeight + "px";
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            }
        });
    });

    /**
     * ADA: Accordion content shouldn’t be navigable when hidden
     * (e.g.: Pressing the tab key on the “Health Benefits” accordion goes to the links
     * within its content even when it is not active).
     */

    (function() {

        // 1. Initial tabindex setting for all accordion panels
        // Select all elements with the class 'accordion-panel'
        const accordionPanels = document.querySelectorAll(".accordion-panel");

        accordionPanels.forEach(function(panel) {
            // Find all focusable elements within each panel
            const focusableElements = panel.querySelectorAll("a, area, button, frame, iframe, input, object, select, textarea, summary");

            // Set tabindex="-1" to make them not focusable by default
            focusableElements.forEach(function(element) {
                element.setAttribute("tabindex", "-1");
            });
        });


        // 2. Click event listener for accordion buttons
        // Select all buttons with the class 'accordion'
        const accordionButtons = document.querySelectorAll("button.accordion");

        accordionButtons.forEach(function(button) {
            button.addEventListener("click", function(event) {
                const accordion = event.target; // The clicked button
                // nextElementSibling gets the element immediately following the button
                const accordionPanel = accordion.nextElementSibling;

                // Ensure accordionPanel exists before proceeding
                if (!accordionPanel) {
                    console.warn("Accordion button has no next sibling panel.", accordion);
                    return;
                }

                // Find all focusable elements within the *specific* accordion panel
                const focusableElementsInPanel = accordionPanel.querySelectorAll("a, area, button, frame, iframe, input, object, select, textarea, summary");

                if (accordion.classList.contains("active")) {
                    // If the accordion button is now active (meaning the panel is open or will be open)
                    focusableElementsInPanel.forEach(function(element) {
                        // element.setAttribute("tabindex", "0"); // Make elements focusable
                        accordion.setAttribute("aria-expanded", "true"); // Update aria-expanded for accessibility
                        accordionPanel.setAttribute("aria-hidden", "false"); // Update aria-hidden for accessibility
                        accordionPanel.removeAttribute("inert"); // Update inert for accessibility
                    });
                } else {
                    // If the accordion button is not active (meaning the panel is closed or will be closed)
                    focusableElementsInPanel.forEach(function(element) {
                        // element.setAttribute("tabindex", "-1"); // Make elements not focusable
                        accordion.setAttribute("aria-expanded", "false"); // Update aria-expanded for accessibility
                        accordionPanel.setAttribute("aria-hidden", "true"); // Update aria-hidden for accessibility
                        accordionPanel.setAttribute("inert", ""); // Update inert for accessibility
                    });
                }
            });
        });
    })();

    /**
     * Count the variant accordions in a "product collection" PDP, if there're <= 3, open them all by default
     */

    (function() {
        const variantAccordions = document.querySelectorAll('.collection-product--variant__ref-product .accordion');
        if (variantAccordions.length <= 3) {
            variantAccordions.forEach(accordion => {
                accordion.click();
            });
        } else {
            variantAccordions[0].click();
        }
    })();

    /**
     * Tabs (todo: use native theme tabs instead—if any)
     */

    function openTab(evt, tabSelector) {
        const tabgroup = evt.currentTarget.closest(".tabgroup");
        const tabcontent = tabgroup.getElementsByClassName("tabcontent");
        const tablinks = tabgroup.getElementsByClassName("tablinks");
        
        // Hide all tab content
        for (let i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }
        
        // Remove active class from all tab links
        for (let i = 0; i < tablinks.length; i++) {
            tablinks[i].classList.remove("active");
            tablinks[i].setAttribute("aria-selected", "false");
        }
        
        // Show selected tab and mark link as active
        tabgroup.querySelector(tabSelector).style.display = "block";
        evt.currentTarget.classList.add("active");
        evt.currentTarget.setAttribute("aria-selected", "true");
    }

    // Event delegation for tab clicks
    document.addEventListener('click', function(evt) {
        // Find the closest tablinks button (handles clicks on child elements like h5)
        const tabButton = evt.target.closest('.tablinks');
        if (tabButton && tabButton.dataset.tab) {
            // Create a new event object with the button as currentTarget
            const syntheticEvent = {
                currentTarget: tabButton,
                target: evt.target,
                preventDefault: () => evt.preventDefault(),
                stopPropagation: () => evt.stopPropagation()
            };
            openTab(syntheticEvent, tabButton.dataset.tab);
        }
    });
    
    const tabGroups = document.querySelectorAll('.tabgroup');
    tabGroups.forEach(tabGroup => {
        const tabButtons = tabGroup.querySelectorAll('.tablinks');
        const tabButtonsArray = Array.from(tabButtons);
        let activeButton = tabGroup.querySelector('.tablinks.active');
        
        // Set initial tabindex: only active button is focusable
        tabButtons.forEach(button => button.setAttribute('tabindex', '-1'));
        if (activeButton) {
            activeButton.setAttribute('tabindex', '0');
        }

        // When focus enters the tab group from outside, focus the active tab
        tabGroup.addEventListener('focusin', (evt) => {
            // Only act if focus is coming from outside the tab group
            if (!tabGroup.contains(evt.relatedTarget)) {
                activeButton = tabGroup.querySelector('.tablinks.active');
                if (activeButton && evt.target !== activeButton) {
                    activeButton.focus();
                }
                // Make all tabs focusable while within the group
                tabButtons.forEach(button => button.setAttribute('tabindex', '0'));
            }
        });

        // When focus leaves the tab group, reset tabindex
        tabGroup.addEventListener('focusout', (evt) => {
            // Only act if focus is moving outside the tab group
            if (!tabGroup.contains(evt.relatedTarget)) {
                activeButton = tabGroup.querySelector('.tablinks.active');
                tabButtons.forEach(button => button.setAttribute('tabindex', '-1'));
                if (activeButton) {
                    activeButton.setAttribute('tabindex', '0');
                }
            }
        });

        // Keyboard navigation for arrow keys
        tabGroup.addEventListener('keydown', (evt) => {
            const currentTab = evt.target.closest('.tablinks');
            if (!currentTab) return;

            const currentIndex = tabButtonsArray.indexOf(currentTab);
            if (currentIndex === -1) return;

            let newIndex;

            if (evt.key === 'ArrowLeft') {
                // Move to previous tab, wrap to last if on first
                newIndex = currentIndex === 0 ? tabButtonsArray.length - 1 : currentIndex - 1;
            } else if (evt.key === 'ArrowRight') {
                // Move to next tab, wrap to first if on last
                newIndex = currentIndex === tabButtonsArray.length - 1 ? 0 : currentIndex + 1;
            } else {
                return; // Not an arrow key we handle
            }

            console.log(`Arrow key pressed. Current index: ${currentIndex}, New index: ${newIndex}, New tab:`, tabButtonsArray[newIndex]);

            evt.preventDefault();
            const newTab = tabButtonsArray[newIndex];
            newTab.focus();
            // Optionally activate the newly focused tab
            // newTab.click();
        });
    });

})();
